import ApiRequest from "../utils/ApiRequest";

export default class Modules {

  getAll = async () => {
    return await ApiRequest.set("/v1/modules", "GET");
  }

  getModuleDetail = async (id) => {
    return await ApiRequest.set(`/v1/modules/${id}`, "GET");
  }

  create = async (module) =>{
    return await ApiRequest.set("/v1/modules", "POST", module)
  }

  createSubmodule = async (subModule) =>{
    return await ApiRequest.set("/v1/submodules", "POST", subModule)
  }

  getSubModuleDetail = async (id) => {
    return await ApiRequest.set(`/v1/submodules/${id}`, "GET");
  }

  editSubmodule = async (submodule,id) =>{
    return await ApiRequest.set(`/v1/submodules/${id}`, "PUT",submodule)
  }

  edit = async (module, id) =>{
    return await ApiRequest.set(`/v1/modules/${id}`, "PUT", module)
  }



}
